import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ramp } from '../models/ramp.model';
import { map } from 'rxjs/operators';
import { Ramp1 } from '../models/ramp1.model';


@Injectable({
  providedIn: 'root'
})
export class RampService {
  private paginationSource = new ReplaySubject<any>(1);
  paginationSettings$ = this.paginationSource.asObservable();

  apiUrl = environment.apiUrl;
  private rampSource = new ReplaySubject<any>(1);
  ramp$ = this.rampSource.asObservable();
 
  constructor(private http: HttpClient) {}

   addRamp(ramp: Ramp) {
    console.log("servisramp")
    console.log(ramp)
    return this.http.post(this.apiUrl + 'api/Rampa',{...ramp });
  }
  getAllRamp(queryParams = {currentPage: 1, itemsPerPage: null, brojRampeQuery: '',ulaznaQuery: null,izlaznaQuery: null,roomNameQuery: '',StatusQuery:'' }) {
    let params = new HttpParams();
    params = params.append('brojRampeQuery', queryParams.brojRampeQuery);
    params = params.append('ulaznaQuery', queryParams.ulaznaQuery);
    params = params.append('izlaznaQuery', queryParams.izlaznaQuery);
    params = params.append('roomNameQuery', queryParams.roomNameQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'api/Rampa/Search',{params, observe: 'response'}).pipe(map((ramp:any) => {
      if(ramp) {
        this.paginationSource.next(JSON.parse(ramp.headers.get('pagination')));
        this.rampSource.next(ramp.body);
      }
    })).toPromise();
  }
  editRamp(ramp) {
    
    return this.http.put(`${this.apiUrl}api/Rampa/${ramp.id}`,ramp);
    
} 
deleteRamp(id) {
  return this.http.delete(`${this.apiUrl}api/Rampa/${id}`);
}

}